export default {
    async setRelatedFilters ({ commit }, relatedFilters) {
        await commit('SET_RELATED_FILTERS', relatedFilters)
    },
    async setTemporalUnpinned ({ commit }, temporalUnpinned) {
        await commit('SET_TEMPORAL_UNPINNED', temporalUnpinned)
    },
}
